export default "__VITE_ASSET__BzKk00lZ__"